import angular from "angular";

angular.module('app')
    .component('cabinetUserCourses', {
        template: require('./cabinet-user-courses.html'),
        controller: ['$http', 'ErrorResponseParser', 'Notifier', 'moment', controller],
        bindings: {
            user: '<',
            courses: '<',
        }
    });


function controller() {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        // console.log($ctrl.courses);
    }

}



